import type { FC } from "react";

import type { Language } from "@ui/components/LanguageSelector";

import { LanguageSelectorListItem } from "../LanguageSelectorListItem";

import styles from "./LanguageSelectorList.module.scss";

type LanguageSelectorListProps = {
  languages: Language[];
  selectedLanguage?: Language;
  onSelectLanguage: (language: Language) => void;
};

export const LanguageSelectorList: FC<LanguageSelectorListProps> = ({
  languages,
  selectedLanguage,
  onSelectLanguage,
}) => {
  return (
    <ul data-testid="languageSelectorPopupList" className={styles.listWrapper}>
      {languages.map((language) => (
        <LanguageSelectorListItem
          key={language.associatedCookieValue}
          language={language}
          onSelectLanguage={onSelectLanguage}
          selectedLanguageCode={selectedLanguage?.associatedCookieValue}
        />
      ))}
    </ul>
  );
};
